import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import axios from "axios";
import {resetPasswordUrl} from "./../../config";
//import NewPasswordForm from "../../components/NewPasswordForm";
import {Link} from "react-router-dom";

class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.mobile = JSON.parse(window.localStorage.getItem("mobile") || null);
    }

    state = {
        mobile: null,
        errorMsg: false,
        new_password: "",
        isError: false,
        loading: false,
        is_verified: false,
        code: null,
    };
    componentDidMount() {
        this.setState({
            mobile: this.mobile,
        })
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };
    newPassword = (e) => {
        // prevent default behavior
        e.preventDefault();
        // start loading
        this.setState({
            loading: true,
        });

        const form = document.getElementById("forget-password-form");

        const errorDesc = document.getElementById("error-msg");

        axios.post(resetPasswordUrl, this.state).then(res => {

            // stop loading
            this.setState({
                loading: false,
            });

            if (res.data.Error.code === 20) {
                // cache user & access token
                this.props.history.push("/login");
                form.reset();
                localStorage.removeItem('mobile')
            } else {
                switch (res.data.Error.code) {
                    case 24:
                        errorDesc.innerHTML = res.data.Error.desc;
                        this.setState({
                            isError: true
                        });
                        break;
                    default:
                        break;
                }
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                loading: true,
            });
        });
    };

    render() {
        const {loading, isError} = this.state;
        const {translate} = this.props;
        return (
            <div>
                <div>
                    <div className="wrap-login100 p-l-50 p-r-50 p-t-120 p-b-50">

                        <form onSubmit={this.newPassword} id="forget-password-form"
                              className="login100-form validate-form">
                            <a href="/" className="logo-auth"> <img src="images/logo.png" alt="seena logo"/>
                            </a>
                            <span className="login100-form-title p-b-59">
                            {translate('new_password')}
                        </span>
                            <span id="error-msg" className="full-width" hidden={isError === false}></span>
                            <div className="wrap-input100 validate-input">
                                <input id="new_password" type="password" className="form-control input100 curvy-input"
                                       onChange={this.handleInputChange}
                                       autoComplete="new-password"
                                       placeholder="Enter your new Password"/>
                            </div>
                            <div className="container-login100-form-btn relative">
                                <button type="submit"
                                        className="login100-form-btn btn-block cursor-pointer curvy-input height-45">{translate("submit")}
                                </button>

                                <span id="loading" className="auth-loading"
                                      hidden={loading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                            </div>
                            <div className="text-center link-area full-width">
                                <Link to="/">{"<- " + translate("back_to_home")}</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}


export default withTranslate(ResetPassword)
